export default __webpack_public_path__ + "static/media/bha.f47d05f7.mp3";